import React, { useEffect } from "react";
import "./AboutUs.css";

const AboutUs = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className="page-container">
      <h1>About Us…</h1>
      <h2>The Biogenix Store</h2>
      <p>
        Our store is an official reseller of the well renown and highly reputable manufacturer of Biogenix Labs products.
      </p>
      <p>
        Our team is here to ensure that all our customers can order and receive genuine Biogenix Labs products quickly, discretely, and safely by using our easy to use website and our first class service.
      </p>
      <p>
        We have made our store as user friendly as can be, keeping it as simple as technically possible, without lots of misleading advertising or unnecessary jargon.
      </p>
      <p>
        We obtain all our Biogenix Labs products directly from Biogenix Labs which means there are no middlemen between us and our customers.
      </p>
      <p>
        Biogenix Labs products are made of extremely high quality pharmaceutical ingredients with super smooth sterile injectables and top quality oral products which cover all aspects of bodybuilding whether it’s the Pro’s at competition level or for the private individual for building muscle, burning fat or just overall body shaping and conditioning.
      </p>
      <p>
        All Biogenix Labs products are kept to within the correct pharmaceutical milligram or microgram ranges and we guarantee this by way of regular batch testing to give our customers peace of mind that what it states on the labels is exactly what is inside. You may view our lab tests here: <a href="#">Lab Test Reports</a>
      </p>
      <p>
        This ensures that from novice to pro, even our most discerning customers can plan their cycles and gains to perfection.
      </p>
    </div>
  );
};

export default AboutUs;
